/* tslint:disable */
/* eslint-disable */
/**
 * Revisdom API
 * Revisdom uygulaması için REST API dokümantasyonu
 *
 * The version of the OpenAPI document: v1
 * Contact: support@revisdom.com
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface RevisdomAPIViewModelsEntryBreadcrumbResponse
 */
export interface RevisdomAPIViewModelsEntryBreadcrumbResponse {
    /**
     * 
     * @type {string}
     * @memberof RevisdomAPIViewModelsEntryBreadcrumbResponse
     */
    name?: string | null;
    /**
     * 
     * @type {string}
     * @memberof RevisdomAPIViewModelsEntryBreadcrumbResponse
     */
    url?: string | null;
}

/**
 * Check if a given object implements the RevisdomAPIViewModelsEntryBreadcrumbResponse interface.
 */
export function instanceOfRevisdomAPIViewModelsEntryBreadcrumbResponse(value: object): value is RevisdomAPIViewModelsEntryBreadcrumbResponse {
    return true;
}

export function RevisdomAPIViewModelsEntryBreadcrumbResponseFromJSON(json: any): RevisdomAPIViewModelsEntryBreadcrumbResponse {
    return RevisdomAPIViewModelsEntryBreadcrumbResponseFromJSONTyped(json, false);
}

export function RevisdomAPIViewModelsEntryBreadcrumbResponseFromJSONTyped(json: any, ignoreDiscriminator: boolean): RevisdomAPIViewModelsEntryBreadcrumbResponse {
    if (json == null) {
        return json;
    }
    return {
        
        'name': json['name'] == null ? undefined : json['name'],
        'url': json['url'] == null ? undefined : json['url'],
    };
}

export function RevisdomAPIViewModelsEntryBreadcrumbResponseToJSON(json: any): RevisdomAPIViewModelsEntryBreadcrumbResponse {
    return RevisdomAPIViewModelsEntryBreadcrumbResponseToJSONTyped(json, false);
}

export function RevisdomAPIViewModelsEntryBreadcrumbResponseToJSONTyped(value?: RevisdomAPIViewModelsEntryBreadcrumbResponse | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'name': value['name'],
        'url': value['url'],
    };
}

